export default 'campaigns';
